
<div class="overflow-hidden">
  <div class="onboarding-form vh-100 overflow-hidden p-3 p-md-5 bg-white">
    <div class="col-12 d-flex flex-column flex-lg-row align-items-stretch g-0 mx-auto justify-content-center bg-white">
      <!-- Image container -->
      <div class="img-container col-lg-6 d-none d-lg-flex align-items-stretch h-100 p-0 justify-content-center overflow-hidden">
        <img :src="$clientImage.onboarding" alt="Image" class="img-fluid auth-image w-100 h-100 rounded-lg shadow-lg object-fit-cover object-position-center" style="object-fit: cover; object-position: center;"/>
      </div>
      
      <!-- Form container -->
      <div class="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 bg-white p-5 p-sm-5 rounded-end-4 rounded-lg-end-4 shadow-lg-only d-flex flex-column justify-content-center mx-auto mx-lg-0 border-0">
        <div class="d-flex flex-column">
          <!-- Logo container -->
          <div class="text-center mb-3 p-0">
            <img :src="$clientLogo" class="img-fluid" width="230">
          </div>
          
          <h5 class="mb-3 text-xs text-center p-0">{{ title }}</h5>
          
          <form @submit.prevent="submitForm" class="d-flex flex-column justify-content-between">
            <slot name="form-content"></slot>
            
            <button
              v-if="show_default_submit_button"
              type="submit"
              class="login-btn btn btn-primary-dark rounded-button shadow w-100"
              :disabled="verification_running"
            >
              {{ submit_button_text }}
            </button>
            
            <slot name="custom-button"></slot>
            <slot name="signup-content"></slot>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>